import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { constants, isEmptyCollection, NumberService } from '@atlas/core';
import { Label, MoneyValue } from '@atlas/ui';

const { BET_TYPE } = constants;

const MultipleBonusInfo = ({
  betAmount = 0,
  currencySymbol = '',
  expressBonusToPossibleWin,
  finalPossibleWin,
  multipleBonus,
  oddsWithPersonalBonus,
  selectedBet,
  selectedFreebet,
}) => {
  const { bonusOnMultipleBetCoefficient, id } = multipleBonus;

  if (!id || !isEmptyCollection(selectedFreebet) || isEmptyCollection(selectedBet)) {
    return null;
  }

  const { betType } = selectedBet;
  const isMultiple = betType === BET_TYPE.MULTIPLE;

  if (!isMultiple) {
    return null;
  }

  const possibleWin = oddsWithPersonalBonus * betAmount;

  const bonus = Math.round(finalPossibleWin) - Math.round(possibleWin);

  const potentialWinClass = cx('potential-win-amount', {
    'bonus-to-possible-win': expressBonusToPossibleWin,
  });

  return (
    <>
      <div className="title-small-text amount-possible-win">
        <div className="label">
          <Label message="possible_win" />:
        </div>
        <MoneyValue className={potentialWinClass} currency={currencySymbol} value={possibleWin} />
      </div>
      <div className="express-bonus-to-possible-win">
        <div className="title-small-text bonus">
          <div className="label">
            + &nbsp;
            <Label message="multiple bonus" />
            <span className="odd-amount">
              {NumberService.oddsToPercentage(bonusOnMultipleBetCoefficient)}
            </span>
          </div>
          <MoneyValue className="potential-win-amount" currency={currencySymbol} value={bonus} />
        </div>
      </div>
    </>
  );
};

MultipleBonusInfo.propTypes = {
  betAmount: PropTypes.number,
  currencySymbol: PropTypes.string,
  multipleBonus: PropTypes.object.isRequired,
  selectedBet: PropTypes.object,
  selectedFreebet: PropTypes.object.isRequired,
};

export default MultipleBonusInfo;
